import {
  PendingWorkspaceTeamEntitlement,
  WorkspacePeopleResponse,
} from "../models/Workspace";

export function getIncludedTeammateSeats(
  teammateCount: number,
  pending: PendingWorkspaceTeamEntitlement | null | undefined,
): number {
  if (!pending) return teammateCount;
  if (!pending.teamEnabled) return 0;
  if (pending.maxMembers === null) return teammateCount;
  return Math.min(teammateCount, Math.max(0, pending.maxMembers - 1));
}

export function formatWorkspaceMemberUsage(
  activeCount: number,
  maxMembers: number | null,
): string {
  return maxMembers === null
    ? `${activeCount} active · Unlimited members`
    : `${activeCount} of ${maxMembers} active seats`;
}

export function isTeammateSeatSelectionRequired(
  teammateCount: number,
  pending: PendingWorkspaceTeamEntitlement | null | undefined,
): boolean {
  return getIncludedTeammateSeats(teammateCount, pending) < teammateCount;
}

export function workspaceRequiresSeatSelection(
  people: WorkspacePeopleResponse,
): boolean {
  if (
    !people.pendingTeamEntitlement ||
    typeof people.pendingTeamEntitlement.confirmedAt === "number"
  ) {
    return false;
  }
  const teammateCount = people.members.filter(
    (member) => member.role === "member",
  ).length;
  return isTeammateSeatSelectionRequired(
    teammateCount,
    people.pendingTeamEntitlement,
  );
}
